import http from "src/libs/http";
import { toast } from "react-toastify";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import MsalInstance from "./authClient";

const baseURL = window._env_.REACT_APP_ASSETS_BASEURL;

const assetClient = http.create({
	baseURL
});

const {
	interceptors: { request, response }
} = assetClient;

request.use(
	async (config) => {
		const activeAccount = MsalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API

		const accounts = MsalInstance.getAllAccounts();

		if (window.authTokens.accessToken) {
			const bearer = `Bearer ${window.authTokens.accessToken}`;
			config.headers!.Authorization = bearer;
			return config;
		}

		if (!activeAccount && accounts.length === 0) {
			/*
			 * User is not signed in. Throw error or wait for user to login.
			 * Do not attempt to log a user in outside of the context of MsalProvider
			 */
			return config;
		}
		const request = {
			scopes: [window._env_.REACT_APP_AD_SCOPE],
			account: activeAccount || accounts[0]
		};

		const authResult = await MsalInstance.acquireTokenSilent(request).catch(
			async (error) => {
				if (error instanceof InteractionRequiredAuthError) {
					// fallback to interaction when silent call fails
					await MsalInstance.acquireTokenRedirect(request);
				}
			}
		);

		const bearer = `Bearer ${authResult?.accessToken}`;
		config.headers!.Authorization = bearer;

		return config;
	},
	async (error) => {
		if (error.request && error.request.status === 403) {
			toast.error("Unauthorized", {
				autoClose: false,
				closeOnClick: false
			});
		}

		if (
			error.request &&
			error.request.headers["content-type"] === "application/json"
		) {
			toast.error(JSON.stringify(error.request), {
				autoClose: false,
				closeOnClick: false
			});
		}

		return Promise.reject(error);
	}
);

response.use(
	async (response) => {
		return response;
	},
	async (error) => {
		if (error.response && error.response.status === 403) {
			toast.error("Unauthorized", {
				autoClose: false,
				closeOnClick: false
			});
		}

		if (
			error.response &&
			error.response.headers["content-type"] === "application/json"
		) {
			toast.error(JSON.stringify(error.response.data));
		}

		return Promise.reject(error);
	}
);

export default assetClient;
